import { render, staticRenderFns } from "./PreguntaCreate.vue?vue&type=template&id=51f67a1e&"
import script from "./PreguntaCreate.vue?vue&type=script&lang=js&"
export * from "./PreguntaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm,QInput,QToolbar,QToolbarTitle,QSpace,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QInput,QToolbar,QToolbarTitle,QSpace,QBtn})
